module.exports = __webpack_public_path__ + "img/Regenerate.f85c28d3.svg";